import {
  Stack,
  styled,
  Typography,
  type CSSObject,
  GridLegacy as Grid,
} from '@mui/material';
import { theme } from '@rumblefish/ui';

export const StyledStack = styled(Stack)(({ theme }) => ({
  flexFlow: 'column nowrap',
  justifyContent: 'space-between',
  alignItems: 'center',
  padding: theme.spacing(12, 0),
  [theme.breakpoints.down('sm')]: {
    padding: theme.spacing(4, 0),
  },
}));

export const StyledTwoTitles = styled(Stack)(({ theme }) => ({
  gap: theme.spacing(3),
  alignItems: 'flex-start',
  zIndex: '1',
  marginBottom: theme.spacing(12),
  [theme.breakpoints.down('sm')]: {
    gridAutoFlow: 'row',
    marginBottom: theme.spacing(4),
  },
}));

export const StyledFirstTitle = styled(Typography)(({ theme }) => ({
  ...(theme.mixins.neutralGradient as CSSObject),
  letterSpacing: '-0.02em',
  display: 'flex',
  justifyContent: 'center',
  backgroundClip: 'text',
  WebkitBackgroundClip: 'text',
  WebkitTextFillColor: 'transparent',
  [theme.breakpoints.down('sm')]: {
    textAlign: 'center',
    alignSelf: 'center',
  },
}));

export const StyledSecondTitle = styled(Typography)(
  ({ theme: { breakpoints } }) => ({
    ...(theme.mixins.neutralGradient as CSSObject),
    color: 'white',
    letterSpacing: '-0.02em',
    display: 'flex',
    [breakpoints.down('sm')]: {
      textAlign: 'center',
    },
  })
);

export const StyledServiceItem = styled(Grid)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'center',
  gap: theme.spacing(2),
  [theme.breakpoints.down('sm')]: {
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    textAlign: 'center',
  },
}));

export const StyledServiceIconWrapper = styled('div')(({ theme }) => ({
  background:
    'radial-gradient(47.45% 48.31% at -0.77% 0%, rgba(255, 255, 255, 0.05) 0%, rgba(255, 255, 255, 0) 100%), rgba(255, 255, 255, 0.03);',
  width: '96px',
  height: '96px',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  borderRadius: '50%',
  marginRight: '20px',
  [theme.breakpoints.down('md')]: {
    marginRight: '0',
    marginTop: '10%',
  },
}));

export const StyledServiceIconBackground = styled('div')(({}) => ({
  background: 'rgba(246, 163, 81,0.05)',
  width: '70px',
  height: '70px',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  borderRadius: '50%',
}));

export const StyledServiceIcon = styled('img')(({}) => ({
  background: 'transparent',
  position: 'relative',
  height: '43px',
  aspectRatio: '1/1',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
}));

export const StyledServiceTitle = styled(Typography)(({ theme }) => ({
  letterSpacing: '-0.02em',
  marginBottom: '10px',
  background:
    'linear-gradient(180deg, #FFFFFF 0%, rgba(217, 217, 217, 0.8) 100%)',
  backgroundClip: 'text',
  WebkitBackgroundClip: 'text',
  WebkitTextFillColor: 'transparent',
  [theme.breakpoints.down('sm')]: {
    marginTop: '10%',
  },
}));

export const StyledServiceDescription = styled(Typography)(() => ({
  color: '#ABB1B4',
  lineHeight: '150%',
  letterSpacing: '-0.01em',
}));

export const StyledServiceList = styled('ul')(({ theme }) => ({
  [theme.breakpoints.down('sm')]: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
  },

  color: theme.palette.invertedContent?.SECONDARY,
  paddingInlineStart: '1rem',
}));
